import axios from "axios";

//const LOCAL_URL = "http://localhost:9000/"; // LOCAL URL OF NODE
const LOCAL_URL = "http://localhost:7090/"; // LOCAL URL OF Server HIL published
// const LOCAL_URL = 'http://192.168.10.252/';
// const LOCAL_URL = "http://localhost:44323/"; // LOCAL URL OF .NET

//const BASE_URL = 'http://localhost:8365/';
// const BASE_URL = 'http://192.168.10.18:3500';
const BASE_URL = "http://2.144.243.196:7090/";

export default axios.create({
  baseURL: window.location.hostname.toLowerCase().includes("localhost")
    ? LOCAL_URL
    : BASE_URL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  },
});

export const axiosPrivate = axios.create({
  baseURL: window.location.hostname.toLowerCase().includes("localhost")
    ? LOCAL_URL
    : BASE_URL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    Accept: "application/json",
  },
  withCredentials: true,
});

export const axiosPrivateFile = axios.create({
  baseURL: window.location.hostname.toLowerCase().includes("localhost")
    ? LOCAL_URL
    : BASE_URL,
  headers: { "Content-Type": "multipart/form-data" },
  withCredentials: true,
});
